import { render, staticRenderFns } from "./Middle.vue?vue&type=template&id=5a0461f8&scoped=true"
import script from "./Middle.vue?vue&type=script&lang=js"
export * from "./Middle.vue?vue&type=script&lang=js"
import style0 from "./Middle.vue?vue&type=style&index=0&id=5a0461f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0461f8",
  null
  
)

export default component.exports